<template>
  <header :class="{ 'header--display': $route.meta.display }">
    <router-link v-if="!$route.meta.display" to="/" class="site-title"> wyniki-online <span>pl</span></router-link>

    <div class="nav" v-if="['Competition', 'ArchivalCompetition', 'Display'].includes($route.name)">
      <button class="item" v-if="showPenalties" @click="$emit('open-modal', 'penalties')">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
          />
        </svg>
        <span>{{ $t("penalties") }}</span>
      </button>

      <div class="ws-status item" v-bind:class="{ online: wsStatus }">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <g><rect fill="none" height="24" width="24" /></g>
          <g>
            <path
              d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M8.46,14.45L7.1,13.83 c0.28-0.61,0.41-1.24,0.4-1.86c-0.01-0.63-0.14-1.24-0.4-1.8l1.36-0.63c0.35,0.75,0.53,1.56,0.54,2.4 C9.01,12.8,8.83,13.64,8.46,14.45z M11.53,16.01l-1.3-0.74c0.52-0.92,0.78-1.98,0.78-3.15c0-1.19-0.27-2.33-0.8-3.4l1.34-0.67 c0.64,1.28,0.96,2.65,0.96,4.07C12.51,13.55,12.18,14.86,11.53,16.01z M14.67,17.33l-1.35-0.66c0.78-1.6,1.18-3.18,1.18-4.69 c0-1.51-0.4-3.07-1.18-4.64l1.34-0.67C15.56,8.45,16,10.23,16,11.98C16,13.72,15.56,15.52,14.67,17.33z"
            />
          </g>
        </svg>
        <span v-if="wsStatus">{{ $t("connected") }}</span>
        <span v-else>{{ $t("disconected") }}</span>
      </div>
    </div>

    <div class="locale">
      <Dropdown fullwidth>
        <button class="locale-btn">
          {{ currentLocale }}

          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
          </svg>
        </button>

        <template #content>
          <ul class="menu">
            <li v-for="lang in langs" :key="lang.value" class="item">
              <button class="link" @click="selectLocale(lang.value)" v-show="$i18n.locale !== lang.value">
                {{ lang.label }}
              </button>
            </li>
          </ul>
        </template>
      </Dropdown>
    </div>
  </header>
</template>

<script>
import Dropdown from "@/components/Dropdown"
import { LOCALES, saveLocale } from "@/locale"

export default {
  name: "Header",

  components: {
    Dropdown,
  },

  props: {
    wsStatus: Boolean,
    showPenalties: Boolean,
  },

  data: () => ({
    langs: LOCALES,
  }),

  computed: {
    currentLocale: function () {
      return this.langs.find((lang) => lang.value === this.$i18n.locale)?.label
    },
  },

  methods: {
    selectLocale(locale) {
      this.$i18n.locale = locale
      saveLocale(locale)
    },
  },
}
</script>

<style scoped lang="scss">
header {
  color: #fff;
  display: flex;
  align-items: center;
  min-height: 4rem;
  flex-wrap: wrap;
  flex-grow: 0;
  background: #000;
  box-shadow: 0 0 1rem rgba(#000, 0.75);
  padding: 0.5rem 1.5rem;
  position: sticky;
  z-index: 10;
  top: 0;

  @media (max-width: 600px) {
    justify-content: center;
  }
}

// W trybie display brak tytułu (który wypychał treść w prawo przez margin-right:auto),
// więc pierwszy widoczny element wypychamy w prawo tutaj.
.header--display .nav {
  margin-left: auto;
}

.site-title {
  color: #fff;
  font-weight: bolder;
  margin-right: auto;

  @media (max-width: 600px) {
    text-align: center;
    flex: 1 1 100%;
  }

  span {
    font-size: 0.65rem;
    font-weight: normal;
    text-transform: uppercase;
    border-radius: 0.35rem;
    padding: 0.15rem 0.75rem;
    background: rgba(#fff, 0.15);
  }
}

.nav {
  padding: 0.5rem 0;
  margin: 0 1rem;
  display: flex;
  align-items: center;

  button {
    &:hover {
      opacity: 0.55;
    }
  }

  .item {
    color: #fff;
    font-weight: bold;
    padding: 0.25rem 1rem;
    display: flex;
    align-items: center;
    font-size: 0.75rem;

    svg {
      fill: currentColor;
      margin-right: 0.5rem;
    }

    &.ws-status {
      color: $warning;

      &.online {
        color: $success;
      }
    }

    @media (max-width: 700px) {
      padding: 0.25rem;
    }
  }
}

.locale {
  &-btn {
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    background: rgba(#fff, 0.15);
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    min-width: 7rem;
    position: relative;

    svg {
      fill: currentColor;
      width: 1rem;
      height: 1rem;
      margin: 0 0.5rem;
      position: absolute;
      right: 0;
    }
  }
}

.menu {
  .item:not(:last-of-type) {
    border-bottom: 1px solid $light;
  }

  .link {
    display: block;
    text-align: left;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    width: 100%;

    &:hover {
      background: $light;
    }
  }
}
</style>
